import styled from "styled-components";

export const ModalBackground = styled.div``;

export const ModalContainer = styled.div<{ $show: boolean }>`
  position: absolute;
  padding: 24px;
  background: white;
  bottom: 6px;
  left: 6px;
  right: 6px;
  height: 0;
  overflow: hidden;
  transition: all 1s ease-in-out;
  transform: translateY(100%);
  border-radius: 15px;
  opacity: 0;

  @keyframes swipeUp {
    0% {
      height: 0;
      transform: translateY(100%);
    }
    50% {
      height: auto;
      transform: translateY(120%);
    }
    100% {
      height: auto;
      transform: translateY(0);
      z-index: 100002;
      opacity: 1;
    }
  }
  @keyframes swipeDown {
    0% {
      height: auto;
      transform: translateY(0);
    }
    50% {
      height: 0;
      transform: translateY(120%);
    }
    100% {
      height: auto;
      transform: translateY(120%);
      opacity: 0;
    }
  }
  ${(props) =>
    props.$show
      ? `
    animation: swipeUp 0.5s forwards;
    `
      : `
      animation: swipeDown 1s forwards;
`}
`;

export const ModalContainerDraggableControl = styled.div`
  position: relative;
  padding-bottom: 32px;
  display: flex;
  width: 100%;

  &:after {
    position: absolute;
    border: 2px solid #d7dbda;
    border-radius: 6px;
    width: 43px;
    left: 50%;
    bottom: top;
    transform: translateX(-50%);
    content: "";
  }
`;

export const ModalContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 32px;
`;

export const ModalContainerContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  text-align: center;
`;

export const ModalContainerCTAButtonDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;
